import React from 'react';
import './TutorialHint.css';

function TutorialHint({ text, position = 'top' }) {
  return (
    <span className={`tutorial-hint tutorial-hint-${position}`} aria-label={text}>
      <span className="tutorial-hint-icon" aria-hidden="true">!</span>
      <span className="tutorial-hint-tooltip" role="tooltip">{text}</span>
    </span>
  );
}

export default TutorialHint;
